import { useEffect } from "react";
import { useTradeInAemSelector } from "../redux/store";
import { MODAL_DIALOG_ID, scrollTargetIntoView } from "../../common-deprecated/utils";
import { useAemNavOffset, useShowAfterFirstRender } from "../../common-deprecated/hooks";

const useTradeInAem = (insideModal?: boolean): void => {
    const step = useTradeInAemSelector((state) => state.tradeInAemNav.step);
    const domTarget = useTradeInAemSelector((state) => state.utils.domTarget);
    const siteNavOffset = useAemNavOffset();
    const isNotFirstRender = useShowAfterFirstRender(true);

    useEffect((): void => {
        // Only trigger the logic after the first render to avoid having this happen on init
        if (isNotFirstRender) {
            if (insideModal) document.getElementById(MODAL_DIALOG_ID)?.scrollTo(0, 0);
            else scrollTargetIntoView(`#${domTarget}`, siteNavOffset);
        }
    }, [step]);
};

export default useTradeInAem;
